import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_DATE_FORMAT } from 'pages/utils/time';
import DateRangePicker from '.';

const VISIBLE_MONTHS = 1;

const DatePicker = ({ date, ...props }) => (
  <DateRangePicker single startDate={date} endDate={date} {...props} />
);

export default DatePicker;

DatePicker.propTypes = {
  dateFormat: PropTypes.string,
  date: PropTypes.shape({
    _isAMomentObject: PropTypes.bool,
  }).isRequired,
  availableStartDate: PropTypes.shape({
    _isAMomentObject: PropTypes.bool,
  }),
  availableEndDate: PropTypes.shape({
    _isAMomentObject: PropTypes.bool,
  }),
  onChange: PropTypes.func.isRequired,
  numberOfMonths: PropTypes.number,
  placement: PropTypes.oneOf([
    'top',
    'top-start',
    'top-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'right',
  ]),
  disabled: PropTypes.bool,
  offset: PropTypes.number,
};

DatePicker.defaultProps = {
  dateFormat: DEFAULT_DATE_FORMAT,
  placement: 'bottom-start',
  numberOfMonths: VISIBLE_MONTHS,
  disabled: false,
};
